<template>
  <simple-button
    v-p-t="20"
    v-p-b="20"
    v-f-size="'14px'"
    v-color:red
    variant="transparent"
    @click="handleClick"
  >
    <base-icon
      v-m-r="10"
      name="arrows_arrow-reply-all"
    />
    <span
      v-text-decoration:underline
      v-text="$t('common.returned')"
    ></span>
  </simple-button>
</template>

<script>
import { mapActions } from 'vuex';

import SimpleButton from 'molecules/common/SimpleButton';

export default {
  name: 'RefundedInfoButton',
  components: {
    SimpleButton,
  },
  props: {
    publicId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.getRefundedTransaction(this.publicId);
    },
    ...mapActions('refund', ['getRefundedTransaction']),
  },
};
</script>
